export default (eventHub, { enabled }, store) => {
  if (enabled) {
    eventHub.$on('eventReport', val => console.log(val.event, val))
  }
}
